export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filtros"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Status"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Loja"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conta"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aplicar"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Limpar tudo"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecionar status"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecionar loja"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inserir número da fatura"])}
}